export default __webpack_public_path__ + "static/layout-do-dark-748ebb573cfda696ebf61cf8df3a79dc.png";